$(document).ready(function () {
    initClockPickers();
    initCheckboxes();
});


function initClockPickers(){
    if($('.open-hours input[type="text"]').length == 0){
        return true;
    }

    $('.open-hours input[type="text"][time="start"]').clockpicker({
		autoclose: true,
		align: 'left',
		afterDone: afterDone()
	});

    $('.open-hours input[type="text"][time="end"]').clockpicker({
		autoclose: true,
		align: 'right',
		afterDone: afterDone()
	});
}

function afterDone(){
	$('input[time="start"]').each(function(){
		var day 		= $(this).attr('day');
		var start_time 	= $(this).val();
		var end_time	= $('input[time="end"][day="'+day+'"]').val();
		if (
			!!start_time
			&& !!end_time
			&& start_time.length >0  
			&& end_time.length > 0
		) {
			if(start_time >= end_time) {
				alert('The End time cant be more then start time.');
				$('input[time="end"][day="'+day+'"]').val('');
				return false;
			};
		}
	});
}

function initCheckboxes() {
	$('.open-hours input[type="checkbox"]').change(function(){
		let checkbox = $(this);
		checkbox.parent().parent().parent().parent().find('input[type="text"]').each(function(a,b,c){
			$(b).prop('disabled', true);
			$(b).parent().parent().toggleClass('d-none d-md-block');
			
			if(checkbox.prop( "checked" )){
				$(b).prop('disabled', false);
			}
		})
	})
}